/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.RecentDocuments";
        /**
         * Component for display of recent documents for the user.
         */
        class ComponentRecentDocuments extends Widgets.ComponentBaseClass {
            constructor(core, container, parent, config) {
                super(core, container, parent);
                this._config = null;
                this._componentReady = false;
                this._displayPending = false;
                this._dataList = null;
                // External interaction
                this.DocumentSelectedCallBack = null;
                // UI Elements
                this._loader = null;
                this._noRecords = null;
                this._listContainer = null;
                this._viewStyles = ['wpt-font-remove_red_eye'];
                this._uploadStyles = ['wpt-font-upload_file'];
                // State
                this._recentItems = null;
                this._storeHtml = (htmlData) => {
                    this._log.info("ComponentRecentDocuments._storeHtml()");
                    ComponentRecentDocuments.Html = htmlData;
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                };
                this._requestHitlist = () => {
                    this._log.info("ComponentRecentDocuments._requestHitlist()");
                    this._core.Loader.genericServiceCall('/User.svc/rest/GetRecentDocuments', this._displayResult, this._errorCallback, this._failCallback);
                };
                this._displayResult = (response) => {
                    this._log.info("ComponentRecentDocuments._displayResult()");
                    this._core.Functions.hideElement(this._loader);
                    this._dataList.clearList();
                    let itemsLength = 0;
                    if (response.hasOwnProperty('RecentItems') && response.RecentItems.length > 0) {
                        this._recentItems = response.RecentItems.sort((a, b) => (a.Timestamp > b.Timestamp) ? -1 : ((b.Timestamp > a.Timestamp) ? 1 : 0));
                        itemsLength = response.RecentItems.length;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got documents: " + itemsLength);
                        }
                        this._core.Functions.hideElement(this._noRecords);
                        let listData = {
                            Items: []
                        };
                        for (let i = 0; i < itemsLength; i++) {
                            let item = response.RecentItems[i];
                            let itemData = {
                                Id: item.Handle.toString(10),
                                DisplayName: item.Name
                            };
                            let icon = {
                                Classes: [...this._viewStyles],
                                Title: this._core.Locale.getTranslation('STR_WPT_RECENT_VIEW')
                            };
                            if (item.Type == 'UPLOAD') {
                                icon.Classes = [...this._uploadStyles];
                                icon.Title = this._core.Locale.getTranslation('STR_WPT_RECENT_UPLOAD');
                            }
                            itemData.PrefixIcons = [icon];
                            listData.Items.push(itemData);
                        }
                        this._dataList.displayData(listData);
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got NO documents");
                        }
                        this._core.Functions.showElement(this._noRecords);
                        this._recentItems = [];
                    }
                };
                this._docSelected = (itemNum) => {
                    this._log.info("ComponentRecentDocuments._docSelected()");
                    let docId = Number(itemNum);
                    let recentRecord = this._recentItems.find(r => r.Handle == docId);
                    if (!recentRecord) {
                        console.warn("Recent Documents Component: Unrecorgnised document handle selected.");
                        return;
                    }
                    this._dataList.clearItemSelection();
                    this._dataList.selectItem(itemNum);
                    if (this.DocumentSelectedCallBack)
                        this.DocumentSelectedCallBack(recentRecord.Document);
                };
                this.refresh = () => {
                    this._log.info("ComponentRecentDocuments.refresh()");
                    if (this._componentReady)
                        this._requestHitlist();
                    else
                        this._displayPending = true;
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("ComponentRecentDocuments::constructor");
                this._config = config;
                // But the html is static
                if (!ComponentRecentDocuments.Html) {
                    core.Loader.getVersionedHTML('widgets/components/recentdocuments.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
                else {
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                }
            }
            _present() {
                this._log.info("ComponentRecentDocuments._present()");
                if (!this._readyToPresent) {
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("not ready - pausing");
                    }
                    this._waitingToPresent = true;
                    return;
                }
                this._container.innerHTML = ComponentRecentDocuments.Html;
                this._loader = this._container.querySelector('.wpt-hourglass');
                this._noRecords = this._container.querySelector('#recentDocsNoRecords');
                this._listContainer = this._container.querySelector('#recentDocsListContainer');
                this._core.Helper.prepareHourglassIcon(this._loader);
                // Translations
                this._core.Helper.setElementTranslation(this._container.querySelector('#recentDocsLoading'), 'STR_WPT_LOADING');
                this._core.Helper.setElementTranslation(this._container.querySelector('#recentDocsNoRecordsLabel'), 'STR_WPT_NOINFO');
                // Options
                if (this._config.hasOwnProperty('ViewIconStyles') && (this._config.ViewIconStyles != null))
                    this._viewStyles = this._config.ViewIconStyles;
                if (this._config.hasOwnProperty('UploadIconStyles') && (this._config.UploadIconStyles != null))
                    this._uploadStyles = this._config.UploadIconStyles;
                let listConfig = {
                    SelectItemCallback: this._docSelected
                };
                this._dataList = new Widgets.ComponentDataList(this._core, this._listContainer, null, listConfig);
                this._dataList.present();
                // Go!
                this._componentReady = true;
                if (this._displayPending)
                    this._requestHitlist();
            }
        }
        ComponentRecentDocuments.Html = null;
        Widgets.ComponentRecentDocuments = ComponentRecentDocuments;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
